import axios from "axios/index";
import api from "../../config/_api";
import {ADHERENTS_UPDATED,MES_INVITATIONS,MES_STRUCTURES} from "../actions/adherents";

const state = {
    adherents: [],
    mesInvitations:[],
    structuresDistinct : [],
    adherent : [],
};
const actions = {
    getAdherents: ({commit, rootGetters}) => {
        axios({url: api.url + 'adherents?structure_id=' + rootGetters.structure_id, method: 'GET' })
            .then(resp => {
                commit('ADHERENTS_UPDATED', resp.data);
            })
            /*.catch(err => {
                console.log("error");
            });*/
    },
    getUtilisateurs: ({commit, rootGetters}) => {
        axios({url: api.url + 'users?structure_id=' + rootGetters.structure_id, method: 'GET' })
            .then(resp => {
                commit('ADHERENTS_UPDATED', resp.data);
            })
            /*.catch(err => {
                console.log("error");
            });*/
    },
    
    getRoleInvitations: ({commit, rootGetters}) => {
        let data ={
            'email' : rootGetters.getProfile.email,
            'id' : rootGetters.getProfile.id,
            };
        axios({url: api.url + 'Role/invitation/',data : data,method: 'POST' })
        .then(result => {
            commit('MES_INVITATIONS', result.data);
        })
        .catch(err => {
            //
        });
    },
    getStructuresDistinct: ({commit, rootGetters}) => {
        axios({url: api.url + 'utilisateur/' + rootGetters.getProfile.id, method: 'POST' })
        .then(result => {
            commit('MES_STRUCTURES', result.data);
             
        })
        .catch(err => {
            
        });
    },

};
const mutations = {
    [ADHERENTS_UPDATED]: (state, adherents) => {
        adherents.sort((a, b) => {
            if (a.fullname < b.fullname) {
                return -1;
            }
            if (a.fullname > b.fullname) {
                return 1;
            }
            return 0;
        });
        state.adherents = adherents;
    },
    [MES_INVITATIONS] : (state, invitations) => {
        state.mesInvitations = invitations;
    },
    [MES_STRUCTURES] : (state, structures) => {
        state.structuresDistinct = structures.structuresDistinct;
    }
    
};
const getters = {
    adherents : state => state.adherents,
    mesInvitations : state => state.mesInvitations,
    structuresDistinct : state => state.structuresDistinct,
    adherentById : (state) => (id) => {
        return state.adherents.find(adherents => adherents.id === id)
    }
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
//# sourceMappingURL=adherents.js.map